<template>
  <div id="layout" class="layout">
    <!-- <div class="header-info">
      <div class="top-left">
        <img src="./logo100.png" alt="" v-if="!imgLogo">
        <img :src="imgLogo" alt="" v-else>
        <div>
          {{headerTitle}}
        </div>
        <div style="margin-left: 20px;" v-if="userInfo.examineQuoteUserId && userInfo.examineMode === '00'">
          <el-tag
            v-if="userOnline"
            type="success"
            effect="dark">
            审单上线
          </el-tag>
          <el-tag
            v-else
            type="danger"
            effect="dark">
            审单下线
          </el-tag>
        </div>
      </div>
      <div class="top-right">
        <div class="stop-order" v-if="userOnline && userInfo.examineQuoteUserId" @click="stopPush">
          <span>停止接单</span>
        </div>
        <div class="later-on-order" v-if="userOnline && isOnExamine && userInfo.examineQuoteUserId" @click="laterOnOrder">
          <span>稍后审单</span>
        </div>
        <div class="bg-user"  >
          <span class="user-name">{{userName}}</span>
          <span class="role-name">{{user.roleName}}</span>
          <span class="button_img" style="margin-left: 4px;overflow: hidden;">
            <img
              class="img-name"
              src="@/assets/images/icon_shang.png"
              style="transition: all 0.3s;"
              :style="{transform: `rotate(${isUser ? '0' : '-180deg'})`}"
            />
          </span>
          <div v-show="isUser">
            <div class="bar-console">
              <span @click="changePassword">修改密码</span>
            </div>
          </div>
          
        </div>
        <img v-if="userInfo.examineQuoteUserId" style="cursor: pointer;user-select: none;width: 25px;margin-right: 20px;" :style="isAudio?'cursor: not-allowed;':''" :src="isAudio?require('@/assets/images/icon_audio_o.png'):require('@/assets/images/icon_audio_c.png')" alt="" @click="handleAudio">

        <div class="bg-white" @click="closeLogin">
          <img src="@/assets/images/-s-icon_gb_.png" alt />
        </div>
      </div>
    </div> -->
    <el-dialog
      class="edit-dialog"
      title="修改密码"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="570px"
      @closed="handleDialogClosed"
    >
      <el-form ref="userform" :rules="userformRule" :model="userform" label-width="80px">
        <el-form-item label="登录账号">
          <el-input disabled v-model="userform.userAcc"  size="medium" placeholder="输入登录账号（6-16位字母数字）"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="userPwdOne">
          <el-input v-model.trim="userform.userPwdOne" type="password" maxlength="16" clearable size="medium" placeholder="支持6-16位字母、数字或组合" @input="limitInput('userPwdOne')"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="userPwdTwo">
          <el-input v-model.trim="userform.userPwdTwo" type="password" maxlength="16" clearable size="medium" placeholder="支持6-16位字母、数字或组合"  @input="limitInput('userPwdTwo')"></el-input>
        </el-form-item>
        
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="butLoading" @click.native="handleSuccess">确定</el-button>
      </span>
    </el-dialog>
    <el-container style="height: 100vh;">
      <Aside />
      <el-container>
        <el-header>
          <div class="top_user">
            <div class="stop-order" v-if="userOnline && userInfo.examineQuoteUserId" @click="stopPush">
              <span>停止接单</span>
            </div>
            <div class="later-on-order" v-if="userOnline && isOnExamine && userInfo.examineQuoteUserId" @click="laterOnOrder">
              <span>稍后审单</span>
            </div>
            <div class="shu_line"></div>
            <div class="user_info">
              <span class="user-name">{{userName}} · </span>
              <span class="role-name"> {{user.roleName}}</span>
              <img class="down_select_cion" src="../assets/images/down_select.png" alt="">
              <template v-if="isUser">
                <div class="bar-console">
                  <span @click="changePassword">修改密码</span>
                </div>
              </template>
            </div>
            <img v-if="userInfo.examineQuoteUserId" style="cursor: pointer;user-select: none;width: 22px;margin-left: 22px;" :style="isAudio?'cursor: not-allowed;':''" :src="isAudio?require('@/assets/images/icon_audio_o.png'):require('@/assets/images/icon_audio_c.png')" alt="" @click="handleAudio">
            <div style="padding: 20px 0;margin-left: 25px;cursor: pointer;display: flex;" @click="closeLogin">
              <img style="width: 22px;height: 22px;" src="@/assets/images/login_out.png" alt />
            </div>
          </div>
          <!--页面标签栏-->
          <div style="padding: 0 20px;">
            <Breadcrumb />
          </div>
        </el-header>

        <el-main>
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { Aside, Breadcrumb } from "./components";
import environments from '@/config/url'
import _api from "@/utils/request";
import { mapState } from "vuex";


const uploadUrl = environments[process.env.VUE_APP_BASE_URL].uploadBaseUrl
export default {
  name: "Layout",
  components: { Aside, Breadcrumb },
  data() {
    return {
      uploadUrl,
      imageUrl:'',
      userImg:'',
      isUser: false,
      headerTitle: "繁星回收后台管理系统",
      userName: "",
      restVisible:true,
      user: {},
      dialogVisible: false,
      userform: {
        userAcc:'',
        userPwdOne: '',
        userPwdTwo: '',
      },
      userformRule: {
        userPwdOne: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 16, message: '长度在6到16个字符', trigger: 'blur' }
        ],
        userPwdTwo: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
          { min: 6, max: 16, message: '长度在6到16个字符', trigger: 'blur' },
          { validator: (rule, value, callback) => {
              if (value !== this.userform.userPwdOne) {
                callback(new Error('确认密码与新密码不一致'));
              } else {
                callback();
              }
            }, trigger: 'blur' }
        ],
      },
      butLoading: false,
      imgLogo:'',
      isReset: false,
      userInfo: localStorage.getItem('user')?JSON.parse(localStorage.getItem('user')):{}
    };
  },
  computed: {
    ...mapState({
      userOnline: (state) => state.tagsView.userOnline,
      isAudio: (state) => state.tagsView.isAudio,
      isOnExamine: (state) => state.tagsView.isOnExamine,
    }),
  },
  created(){
    this.imgLogo = JSON.parse(localStorage.getItem('user')).companyLogo
    this.userImg=localStorage.getItem('userImg')
    this.userName=localStorage.getItem('userName')
    this.user=JSON.parse(localStorage.getItem('user'))
    this.headerTitle = '回收商后台-' + this.user.merchantName
    document.body.addEventListener('click',(e)=>{
      if(e.target.className == 'user_info'||e.target.className == 'role-name'||e.target.className == 'user-name' ||e.target.className == 'button_img'||e.target.className =='img-name'){
        this.isUser = !this.isUser
      }else{
        this.isUser = false
      }
    })
  },
  methods: {
    closeLogin() {
      this.$confirm('你是否要退出登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$message({
            type: 'success',
            message: '退出登录成功!'
          })

          if(this.userInfo && this.userInfo.examineQuoteUserEnable){
            _api.examineSignOut().then(res =>{
              sessionStorage.removeItem('userOnline')
              this.$store.commit("tagsView/SET_USERONLINE", false);
              _api.logout({token:localStorage.getItem('token')}).then(res => {
                if(res.code === 1){
                  localStorage.clear()
                  this.$router.push("/login")
                }
              })
            })
          }else{
            _api.logout({token:localStorage.getItem('token')}).then(res => {
              if(res.code === 1){
                localStorage.clear()
                this.$router.push("/login")
              }
            })
          }
          
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });          
        });
    },
    // 打开修改密码弹框
    changePassword() {
      this.userform.userAcc = this.user.userAcc
      this.dialogVisible = true
      this.isUser = false
    },
    handleDialogClosed(){
      this.$refs['userform'].resetFields();
    },
    handleSuccess(){
      console.log(this.userform);
      this.$refs['userform'].validate((valid) => {
        if (valid) {
          this.butLoading = true;
          _api.assignStaffAcc(this.userform).then(res => {
            if(res.code==1){
              this.$message.success('操作成功')
              this.dialogVisible = false
              this.$router.push("/login")
            }
          }).finally(() => {
            this.butLoading = false;
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 开启提示音
    handleAudio() {
      this.$store.commit("tagsView/SET_AUDIOOPEN", true);
    },
    stopPush() {
      this.$confirm('是否确认停止接单？', '退出操作', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.commit("tagsView/SET_USERONLINE", false);
        _api.examineSignOut().then(res => {
          sessionStorage.removeItem('userOnline')
          location.reload();
        })
        
      })
    },
    laterOnOrder() {
      this.$confirm('当前正在审单，是否确定稍后再审？', '退出操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let orderNo = sessionStorage.getItem('nextOrderNo') || ''
        if(orderNo){
          _api.grabCancel({orderNo})
          location.reload();
        }
      })
    },
    limitInput(key) {
      this.userform[key] = this.userform[key].toString().replace(/[^a-zA-Z0-9]/g,'');
    }
  }
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.layout {
  aside,
  main {
    /*滚动条样式设置*/
    &::-webkit-scrollbar {
      width: 0.4em;
      height: 0.4em;
    }
    &:hover::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.1);
      border-radius: 0.5em;
      -webkit-box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
    }
    /*滑块*/
    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.1);
      border-radius: 0.5em;
      -webkit-box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
    }
    /*滑块轨道*/
    &::-webkit-scrollbar-track {
      border-radius: 0.5em;
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
    }
  }
  .el-main {
    padding: 10px 20px;
  }
  .el-header {
    width: 100%;
    font-size: 12px;
    background-color: #f5f6fa;
    color: #333;
    //line-height: 60px;
    height: auto !important;
    // box-shadow: 0px 1px 3px 0px rgba(208, 208, 208, 0.8);
    padding: 0 !important;
    .top_user{
      width: 100vw;
      height: 65px;
      margin-left: -210px;
      background-image: url("../assets/images/top_user_bg.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-right: 20px;
      .stop-order{
        width: 88px;
        height: 32px;
        background: #F8561E;
        border-radius: 16px;
        font-weight: 400;
        font-size: 14px;
        color: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin-right: 10px;
      }
      .later-on-order{
        width: 88px;
        height: 32px;
        background: #2384FC;
        border-radius: 16px;
        font-weight: 400;
        font-size: 14px;
        color: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
      .shu_line{
        width: 1px;
        height: 18px;
        background: #D3DAE8;
        margin: 0 20px;
      }
      .user_info{
        padding: 0 12px;
        height: 32px;
        background: #FFFFFF;
        border-radius: 16px;
        border: 1px solid #D3DAE8;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        .user-name{
          font-weight: 400;
          font-size: 14px;
          color: #2A2A2A;
        }
        .role-name{
          font-weight: 500;
          font-size: 12px;
          color: #FF8B0E;
        }
        .down_select_cion{
          width: 8px;
          height: 6px;
          margin-left: 10px;
        }
        .bar-console {
          z-index: 9999;
          position: absolute;
          top: 55px;
          width: 100px;
          height: 40px;
          background: rgba(255, 255, 255, 1);
          box-shadow: 0px 4px 10px 0px rgba(92, 92, 92, 0.15);
          opacity: 0.9;
          border-radius: 10px;
          display: flex;
          flex-direction: column;
          overflow: hidden;
           span {
            cursor: pointer;
            width: 100%;
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            font-weight: 500;
            color: rgba(102, 102, 102, 1);
            &:hover {
              background-color: rgba(#d4d9f8, 0.5);
            }
          }
        }
      }
    }
  }

  .el-aside {
    color: #333;
  }

  .header-info {
    height: 50px;
    background: #0981ff;
    color: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .top-left {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      word-break: break-all;
      margin-left: 23px;
      height: 50px;
      // line-height: 50px;
      font-size: 20px;
      font-family: MF LangQian (Noncommercial);
      font-weight: 400;
      color: #ffffff;
      // margin-left: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        // border-radius:18px;
        max-width: 120px;
        height: 36px;
        margin:0 5px 0 0;
      }
    }
    .top-right {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 50px;
      margin-right: 20px;
      .bg-white {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          border-radius: 50%;
          width: 70%;
          object-fit: contain;
        }
      }
      .bg-user {
        cursor: pointer;
        display: flex;
        align-items: center;
        // width: 63px;
        height: 20px;
        font-size: 14px;
        font-family: FZLanTingHei-M-GBK;
        font-weight: 400;
        color: #ffffff;
        margin: 0 20px 0 10px;
        
        
        .button_img {
          display: flex;
          align-items: center;
          width: 12px;
          height: 15px;
          border-radius: 3px;
          cursor: pointer;
          > img {
            vertical-align: middle;
          }
        }
      }
    }
  }
  /deep/.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .name-input{
    /deep/.el-input{
      // width: 365px;
    }
  }
  .userAcc{
    /deep/.el-input{
      width: 290px;
    }
    /deep/.el-button{
      padding: 10px 10px;
    }
  }
  .userPwdOne{
    /deep/.el-input{
      width: 345px;
    }
    /deep/.el-button{
      padding: 10px 10px;
    }
  }
}
</style>
